<script>
  import { soundBlobs, sounds, loading } from "../js/stores.js"
  // import { onMount } from "svelte";

  function loadSounds() {
    $sounds.correct = document.getElementById("sound-correct")
    $sounds.click = document.getElementById("sound-click")
    $sounds.hover = document.getElementById("sound-hover")
    $sounds.wrong1 = document.getElementById("sound-wrong1")
    $sounds.wrong2 = document.getElementById("sound-wrong2")
    $sounds.rocketLaunch = document.getElementById("sound-rocket-launch")
    $sounds.finale = document.getElementById("sound-finale")
  }

  $: if (!$loading) {
    loadSounds()
    // console.log($soundBlobs);
  }
</script>

<audio id="sound-click" src={$soundBlobs[0]} type="audio/mpeg" />
<audio id="sound-correct" src={$soundBlobs[1]} type="audio/mpeg" />
<audio id="sound-hover" src={$soundBlobs[2]} type="audio/mpeg" />
<audio id="sound-wrong1" src={$soundBlobs[3]} type="audio/mpeg" />
<audio id="sound-wrong2" src={$soundBlobs[4]} type="audio/mpeg" />
<audio id="sound-rocket-launch" src={$soundBlobs[5]} type="audio/mpeg" />
<audio id="sound-finale" src={$soundBlobs[6]} type="audio/mpeg" />
